var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Return 'a' for build link element else return a 'div' form build div
 *
 * @param haveLink
 */
var getLinkTag = function (haveLink) { return (haveLink ? 'a' : 'div'); };
/**
 * Return row props
 *
 * @param label
 * @param level
 * @param onOver
 * @param index
 * @param overEffectClass
 * @param columnType
 * @param slug
 */
var getRowProps = function (label, level, index, overEffectClass, columnType, slug) {
    if (slug === void 0) { slug = ''; }
    return ({
        className: "row-level-" + level + (columnType ? ' column' : '') + "\n  " + (label ? '' : ' no-title') + (overEffectClass ? ' active' : '') + " " + slug,
        key: "row-props-" + (level || 0) + "-" + (index ? level : 0),
    });
};
/**
 * Return content props
 *
 * @param url
 * @param overEffectClass
 * @param level
 * @param index
 * @param onOver
 * @param target
 */
var getContentProps = function (url, overEffectClass, level, index, target) {
    var attributes = {
        className: "content-level-" + level + (overEffectClass ? ' active' : ''),
        'data-index': index,
        href: url || undefined,
    };
    if (target) {
        return __assign(__assign({}, attributes), { target: target });
    }
    return attributes;
};
/**
 * Return list props
 *
 * @param level
 */
var getListProps = function (level) { return ({
    className: "list-level-" + (level + 1),
}); };
/**
 * Return link props
 *
 * @param category
 * @param index
 * @param onOver
 * @param activeIndex
 * @param activeSubIndex
 */
export var getLinkProps = function (category, index, onOver, activeIndex, activeSubIndex) {
    var url = category.url, title = category.title, level = category.level, imageFilename = category.imageFilename, __children = category.__children, columnType = category.columnType, isExternal = category.isExternal;
    return {
        activeIndex: activeIndex,
        activeSubIndex: activeSubIndex,
        children: __children || [],
        columnType: columnType,
        image: imageFilename,
        index: index,
        key: "link-level-" + (level || 0) + "-" + (index || 0),
        label: title,
        level: level,
        onOver: onOver,
        target: isExternal ? '_blank' : undefined,
        url: url,
        rel: isExternal ? 'noopener' : undefined
    };
};
/**
 * Check if content is available in category
 * @param image
 * @param label
 */
export var checkContentIsAvailable = function (image, label) { return !!image || !!label; };
/**
 * Check if image is available in category
 * @param image
 */
export var checkImageIsAvailable = function (image) { return !!image; };
/**
 * Check if label is available in category
 * @param label
 */
export var checkLabelIsAvailable = function (label) { return !!label; };
/**
 * Check if children are available in category
 * @param children
 */
export var checkChildrenAreAvailable = function (children) {
    return !!(children && typeof children === 'object' && Array.isArray(children) && children.length);
};
/**
 * Return Link built state
 *
 * @param props
 */
export var updateState = function (props) {
    var label = props.label, url = props.url, level = props.level, index = props.index, activeIndex = props.activeIndex, activeSubIndex = props.activeSubIndex, columnType = props.columnType, slug = props.slug, target = props.target;
    var overEffectClass = false;
    if (level === 2) {
        overEffectClass = activeIndex === index;
    }
    if (level === 3) {
        overEffectClass = activeSubIndex === index;
    }
    return {
        Tag: getLinkTag(!!url),
        contentProps: getContentProps(url, overEffectClass, level, index, target),
        listProps: getListProps(level),
        rowProps: getRowProps(label, level, index, overEffectClass, columnType, slug),
    };
};
//# sourceMappingURL=Link.functions.js.map